module.exports = __webpack_public_path__ + "iac-circle-logo.svg";